import { useEffect } from 'react';
import { useFlag } from '@rsos/flags';
import { centerMapOnJursidiction } from './utils';

const useCenterMap = ({
  map,
  boundingBox,
  isAllView,
  hasW3w,
  triggerViewJurisdiction,
}) => {
  const isSoupMapImprovementsOn = useFlag('team-soup-map-improvements');
  /**
   * Original behavior which will trigger jursidiction view when the
   * event pane / call pane closes.
   */
  useEffect(() => {
    if (isSoupMapImprovementsOn) return;

    let bounding;
    if (Array.isArray(boundingBox) && boundingBox.length > 0) {
      bounding = boundingBox[0];
    }
    if (!hasW3w && map && isAllView && bounding) {
      centerMapOnJursidiction(boundingBox, map);
    }
  }, [map, boundingBox, isAllView, hasW3w, triggerViewJurisdiction]);

  /**
   * New use effect hidden behind 'team-soup-map-improvements' flag
   *
   * Same as above but centerMapOnJursidiction already checks a lot of the
   * data, so I removed the duplicate checks.  Also adjusted the dependency to
   * only trigger and update when hasW2W or triggerViewJurisdiction changes.
   * Ticket: https://rapidsos.atlassian.net/browse/SOUP-5
   */
  useEffect(() => {
    if (!isSoupMapImprovementsOn) return;

    if (!hasW3w) {
      centerMapOnJursidiction(boundingBox, map);
    }
  }, [triggerViewJurisdiction]);
};

export default useCenterMap;
